import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PlayerState {
  volume: number;
  [key: string]: any;
}

const initialState: PlayerState = {
  volume: 1
};

const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    updatePlayerSettings(state, action: PayloadAction<Partial<PlayerState>>) {
      Object.assign(state, action.payload);
    },
    setVolume(state, action: PayloadAction<number>) {
      state.volume = action.payload;
    },
    resetPlayerSettings() {
      return initialState;
    }
  }
});

export const {
  updatePlayerSettings,
  setVolume,
  resetPlayerSettings
} = playerSlice.actions;

export default playerSlice.reducer;